import React from "react";

const SystemStatusFooter: React.FC = () => {
  return (
    <footer className="portal-footer">
      <div className="system-status">
        <div className="status-header">
          <i className="fa fa-pulse"></i>
          <span>System Status</span>
          <div className="badge">Partial Degradation</div>
        </div>
        <div className="uptime-meta">
          Uptime: <span>99.99%</span>
          Incidents (30d): <span>0</span>
          <a href="#" style={{ color: '#64748b', marginLeft: '12px', textDecoration: 'none' }}>
            Status Page <i className="fa fa-external-link" style={{ fontSize: '10px' }}></i>
          </a>
        </div>
      </div>

      <div className="services-grid">
        <div className="service-status">
          <div className="dot"></div>
          <span>API Gateway</span>
          <span className="latency">12ms</span>
        </div>
        <div className="service-status">
          <div className="dot"></div>
          <span>Ingredient DB</span>
          <span className="latency">23ms</span>
        </div>
        <div className="service-status">
          <div className="dot"></div>
          <span>Formulation Engine</span>
          <span className="latency">45ms</span>
        </div>
        <div className="service-status">
          <div className="dot"></div>
          <span>Auth Service</span>
          <span className="latency">8ms</span>
        </div>
        <div className="service-status">
          <div className="dot"></div>
          <span>Marketplace</span>
          <span className="latency">18ms</span>
        </div>
        <div className="service-status degraded">
          <div className="dot"></div>
          <span>Webhooks</span>
          <span className="latency">120ms</span>
        </div>
      </div>

      <div className="footer-links">
        <div className="left">Journey AI Developer Portal v3.2.1</div>
        <div className="right">
          <a href="#">Terms</a>
          <a href="#">Privacy</a>
          <a href="#">Documentation</a>
          <span>© 2026 Journey Foods, Inc.</span>
        </div>
      </div>
    </footer>
  );
};

export default SystemStatusFooter;
